import GradePage from "@/pages/GradePage";
export default function GradeGrade8() {
  return <GradePage grade="8" />;
}
